"use client"

import { AlertCircle, Wand2 } from "lucide-react"
import { Button } from "../ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card"

export default function GrammarCheckPanel({ suggestions, onApplySuggestion, onApplyAll }) {
  if (suggestions.length === 0) return null

  return (
    <Card className="mb-4 border-yellow-200 bg-yellow-50">
      <CardHeader>
        <CardTitle className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <AlertCircle size={20} className="text-yellow-600" />
            <span className="text-yellow-800">Grammar Suggestions</span>
          </div>
          <Button size="sm" onClick={onApplyAll} className="bg-green-600 hover:bg-green-700 text-white">
            <Wand2 size={16} className="mr-1" />
            Apply All
          </Button>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {suggestions.map((suggestion, index) => (
            <div key={index} className="flex items-center justify-between p-2 bg-white rounded border">
              <div className="flex-1">
                <span className="text-red-600 line-through">{suggestion.original}</span>
                <span className="mx-2">→</span>
                <span className="text-green-600 font-medium">{suggestion.suggestion}</span>
              </div>
              <Button size="sm" variant="outline" onClick={() => onApplySuggestion(suggestion)} className="ml-2">
                Apply
              </Button>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
